/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, cx, jsx } from '@atlaskit/css';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	root: {
		paddingInline: token('space.200'),
		paddingBlock: token('space.250'),
	},
	withBorder: {
		borderBlockEndStyle: 'solid',
		borderBlockEndWidth: token('border.width'),
		borderBlockEndColor: token('color.border'),
	},
});

type FormSectionProps = {
	children: React.ReactNode;
	hasBorder?: boolean;
};

/**
 * __Form section__
 *
 * A section within the appearance controls form, with optional border.
 */
const FormSection = ({ children, hasBorder }: FormSectionProps) => {
	return (
		<Box xcss={cx(styles.root, hasBorder && styles.withBorder)}>
			<Stack space="space.150">{children}</Stack>
		</Box>
	);
};

export default FormSection;
